import * as React from 'react';
import { List } from 'semantic-ui-react';
export var StatisticsTableDescription = function () { return (<List as='ol'>
		<List.Item as='li' value='*'>
			<b>0</b> - Data jsou dostupná, hodnota je 0.
		</List.Item>
		<List.Item as='li' value='*'>
			<b>No data</b> - Informace o hodnotě není ze zdroje dostupná.
		</List.Item>
	</List>); };
